import { api } from '../utils/api';

export interface CreatePaymentPayload {
  orderId: string | number;
  tableId: string | number;
  amount: number;
  method: string;
  cashRegisterId: string | number;
  received?: number;
  change?: number;
}

export async function createPayment(payload: CreatePaymentPayload) {
  const { data } = await api.post('/payments', payload);
  return data;
}
